<template>
    <section class="card-download" id="card-download">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="title-wrap">
                        <h1>收集卡下載</h1>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="img-wrap">
                        <img :src="card" alt="">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="download-wrap">
                        <!-- <a target="_blank" class="bd-btn" href="./src/assets/pxmart-printingList1123_sc9v2.pdf">下載印花清單</a> -->
                        <button class="bd-btn download-card" @click="printImg(card)">下載活動收集卡</button>
                    </div>     
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import card from '../assets/card.png';


export default {
    data(){
        return {
            card,
        }
    },
    methods: {
        printImg(url){
            var pwin = window.open(url, "_blank");
            pwin.onload=function(){
                pwin.focus();
            }
            pwin.print();
        },
        ga_func(class_name, name){
            $("body").on('click', class_name , function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        }
    },
    mounted(){
        this.ga_func(".download-card", "首頁-下載活動收集卡");

        console.log("cdDown!!")
    }

}


</script>


<style lang="sass">
.card-download
    .title-wrap
        border-top: 2px solid rgba(black, 0.2)
        margin-bottom: 70px
        padding-top: 100px
        @media (max-width: 768px)
            padding-top: 50px
            margin-bottom: 50px
        h1
            text-align: center
    .img-wrap
        img
            width: 100%
    .download-wrap
        margin-top: 80px
        @media (max-width: 576px)
            margin-top: 40px

</style>



// WEBPACK FOOTER //
// src/Index/CardDownload.vue